import NoDataYet from '@/components/NoDataYet';
import BaseIconSvg from '@/components/bases/BaseIconSvg';
import RecursivelyCreateForm from '@/screens/CreateEmr/RecursivelyCreateForm';
import quickModal from '@/utils/quickModal';
import { Button, Form } from 'antd';
import { FormListFieldData } from 'antd/lib';
import _ from 'lodash';
import * as React from 'react';

export interface IFormListProps {
  fieldConfig: IFieldConfig;
  parentNames: string[];
  disabled: boolean;
  isEdit?: boolean;
}

const FormList: React.FC<IFormListProps> = ({ fieldConfig, disabled, parentNames, isEdit, ...props }) => {
  const isMultiple = !!fieldConfig?.extra?.multiple;
  let initValues: any[] | undefined = undefined;

  if (!isMultiple) initValues = !disabled ? [{}] : undefined;

  return (
    <Form.List
      initialValue={initValues}
      rules={[
        {
          validator: (rule, value, callback) => {
            const validator = fieldConfig?.extra?.validator || {};
            let messageError = '';
            Object.keys(validator).forEach((k) => {
              const o = _.isArray(validator[k]) ? validator[k] : [validator[k]];
              const listLength = value?.length || 0;
              switch (k) {
                case 'min':
                  if (listLength < o[0]) {
                    messageError = o[1] || `${fieldConfig.label} phải nhiều hơn ${o[0]} phẩn tử`;
                  }
                  break;
                case 'max':
                  if (listLength > o[0]) {
                    messageError = o[1] || `${fieldConfig.label} phải nhỏ hơn ${o[0]} phẩn tử`;
                  }
                  break;
              }
            });
            if (messageError) {
              callback(messageError);
            } else {
              callback();
            }
          },
        },
      ]}
      name={[...parentNames]}
    >
      {(fields, { remove, add }, { errors }) => {
        if (!isMultiple && !fields?.length) {
          fields = [{}] as FormListFieldData[];
        }

        if (!fields?.length && isMultiple && disabled) {
          return (
            <div className="p-10 w-full">
              <NoDataYet />
            </div>
          );
        }

        return (
          <React.Fragment>
            {/* Thông báo lỗi FormList */}
            <div className={isMultiple ? 'w-full' : ''}>
              <Form.ErrorList className="text-red-9 text-xs" errors={errors} />
            </div>
            {fields?.map((field: any, i: number) => {
              return (
                <React.Fragment key={i.toString()}>
                  {isMultiple ? (
                    <div className="flex justify-between w-full">
                      <div className="font-bold text-orange-8 border-b pb-2 mb-2 w-full ">
                        {fieldConfig.label} {i + 1}
                      </div>
                      <div
                        className={`cursor-pointer  ${disabled ? 'hidden' : ''}`}
                        onClick={async () => {
                          const confirm = await quickModal.confirm({ content: 'Bạn có chắc muốn xóa ' });
                          confirm && remove(i);
                        }}
                      >
                        <Button
                          className="rounded-full flex items-center justify-center p-[2px] text-gray-8 hover:text-mint-8"
                          icon={<BaseIconSvg src="/icons/Regular/Trash - icon.svg" className="" />}
                        ></Button>
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}
                  <RecursivelyCreateForm
                    isEdit={isEdit}
                    key={i.toString()}
                    emrType={fieldConfig.emr}
                    fields={fieldConfig.emr?.format?.fields}
                    parentNames={[field.name, 'data']}
                    disabled={disabled}
                  />
                </React.Fragment>
              );
            })}
            {isMultiple && (
              <div
                className={`font-bold text-orange-8 cms-h6 uppercase cursor-pointer tex ${disabled ? 'hidden' : ''}`}
                onClick={() => {
                  add({});
                }}
              >
                + Thêm {fieldConfig.label}
              </div>
            )}
          </React.Fragment>
        );
      }}
    </Form.List>
  );
};
export default FormList;
